/** Enables new-menu colors on public auth pages (login, signup, password flows). */
export function applyAuthNewTheme(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.add('eb-new-theme');
}
